import { Link } from "react-router-dom";
import { Crown, Clock, ChevronRight } from "lucide-react";

export const GroupCard = ({ g, onOpen }) => {
  const pending = g.status === "pending";
  const body = (
    <div className="flex items-center gap-3">
      <div className="h-11 w-11 shrink-0 rounded-xl bg-gradient-to-br from-[#2563EB] to-[#1E3A8A] flex items-center justify-center font-semibold text-white">
        {g.name.charAt(0).toUpperCase()}
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-1.5 text-sm font-semibold text-[#F3F4F6]">
          <span className="truncate">{g.name}</span>
          {g.is_admin && <Crown className="h-3.5 w-3.5 text-[#F59E0B] shrink-0" aria-label="Admin" />}
        </div>
        <div className="text-[11px] text-[#9CA3AF] truncate">
          {pending ? "Waiting for the admin to approve you" : `${g.member_count} ${g.member_count === 1 ? "member" : "members"} · ${g.note_count} ${g.note_count === 1 ? "note" : "notes"}`}
        </div>
      </div>
      {pending ? (
        <span className="text-[10px] px-2 py-1 rounded-full bg-[#F59E0B]/15 text-[#FBBF24] flex items-center gap-1"><Clock className="h-3 w-3" /> Pending</span>
      ) : g.pending_count > 0 ? (
        <span data-testid={`group-requests-badge-${g.group_id}`} className="text-[10px] px-2 py-1 rounded-full bg-[#2563EB]/20 text-[#93C5FD]">{g.pending_count} to approve</span>
      ) : <ChevronRight className="h-4 w-4 text-[#6B7280]" />}
    </div>
  );
  const cls = "block rounded-2xl bg-[#121212] border border-[#1E1E1E] px-4 py-3.5 transition-colors";
  return pending
    ? <div data-testid={`group-card-${g.group_id}`} className={`${cls} opacity-80`}>{body}</div>
    : <Link to={`/groups/${g.group_id}`} onClick={onOpen} data-testid={`group-card-${g.group_id}`} className={`${cls} hover:border-[#2563EB]/60`}>{body}</Link>;
};
